document.addEventListener("DOMContentLoaded", function() {
  // Arrays to store product data
  let selectedProductIds = [];
  let selectedScentNotes = [];
  let selectedProductImages = [];
  let selectedCandlePrices = [];

  // 1) Utility function: Recalculate totals and update the price display
  function updateBundlePricing() {
    // Sum all currently selected candle prices (in decimal form), ignoring undefined
    let sum = selectedCandlePrices.reduce((acc, price) => {
      return price ? acc + price : acc;
    }, 0);

    // 10% discount
    let discount = sum * 0.10;
    let discountedPrice = sum - discount;

    // Update the text in your HTML
    // Make sure these selectors match your markup
    document.querySelector('.old-price').innerText = `$${sum.toFixed(2)}`;
    document.querySelector('.current-price').innerText = `$${discountedPrice.toFixed(2)}`;
  }

    
  // 2) Attempt to load saved selections from localStorage (if any)
  let savedSelections = localStorage.getItem('bundleSelections');
  if (savedSelections) {
    try {
      savedSelections = JSON.parse(savedSelections);
    } catch (error) {
      console.error("Error parsing saved selections:", error);
      savedSelections = null;
    }
  }

  // Close all dropdowns on page load
  document.querySelectorAll('.dropdown-content').forEach(function(content) {
    content.classList.remove('show');
  });

  // 3) Dropdown click to toggle visibility
  document.querySelectorAll('.custom-dropdown').forEach(function(dropdown) {
    dropdown.addEventListener('click', function(e) {
      e.stopPropagation();
      const content = dropdown.querySelector('.dropdown-content');
      // Close all other dropdowns
      document.querySelectorAll('.dropdown-content').forEach(function(otherContent) {
        if (otherContent !== content) {
          otherContent.classList.remove('show');
        }
      });
      content.classList.toggle('show');
    });

    // 4) Option selection inside dropdown
    dropdown.querySelectorAll('.dropdown-option').forEach(function(option) {
      option.addEventListener('click', function(e) {
        e.stopPropagation();

        // Retrieve data from the clicked option
        const variantId   = option.getAttribute('data-variant-id');
        const scentNotes  = option.getAttribute('data-notes');
        const productImage= option.getAttribute('data-image');
        const productHandle = option.getAttribute('data-handle');
        const index       = dropdown.getAttribute('data-index');
        
        // IMPORTANT: If your store returns product.price in cents, divide by 100
        const rawPrice    = parseFloat(option.getAttribute('data-price'));
        const price       = rawPrice / 100; // convert to decimal dollars

        // Update the UI
        document.getElementById("selected-candle-" + index).innerText = option.querySelector('span').innerText;
        document.getElementById("scent-notes-" + index).innerText = "Scent Notes: " + scentNotes.trim();

        const imageElement = document.getElementById("image-candle-" + index);
        imageElement.src = productImage;
        imageElement.dataset.handle = productHandle;

        // Store product data in arrays
        selectedProductIds[index - 1]   = variantId;
        selectedScentNotes[index - 1]  = scentNotes;
        selectedProductImages[index - 1]= productImage;
        selectedCandlePrices[index - 1] = price;

        // Update bundle pricing
        updateBundlePricing();

        // Save updated selections to localStorage
        localStorage.setItem('bundleSelections', JSON.stringify({
          selectedProductIds,
          selectedScentNotes,
          selectedProductImages,
          selectedCandlePrices
        }));

        // Close the dropdown
        dropdown.querySelector('.dropdown-content').classList.remove('show');
      });
    });
  });

  // 5) Close dropdowns when clicking outside
  document.addEventListener('click', function() {
    document.querySelectorAll('.dropdown-content').forEach(function(content) {
      content.classList.remove('show');
    });
  });

  // 6) Candle images: go to product page on click
  document.querySelectorAll('.candle-image').forEach(function(image) {
    image.addEventListener('click', function() {
      const handle = image.dataset.handle;
      if (handle) {
        window.location.href = "/products/" + handle;
      } else {
        alert("Please select a product first.");
      }
    });
  });

  // 7) Add to cart button
  document.getElementById("add-bundle-to-cart").addEventListener("click", function(event) {
    let selectedCandles = [];
    let totalDiscount = 0;
  
    // Check if all 3 selections are made
    if (selectedProductIds.length < 3 || selectedProductIds.includes(undefined)) {
      alert("Please select 3 candles to proceed.");
      return;
    }
  
    // Build the items array with the selected products and quantities
    selectedProductIds.forEach((variantId, index) => {
      if (variantId) {
        let price = selectedCandlePrices[index];
        let discount = price * 0.10;
        totalDiscount += discount;
  
        selectedCandles.push({
          id: variantId,
          quantity: 1,
          properties: {
            _bundle_discount: discount.toFixed(2)
          }
        });
      }
    });
  
    console.log('Selected Candles:', selectedCandles);
  
    // Send the request to add selected candles to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: selectedCandles })
    })
    .then(response => response.json())
    .then(data => {
      // First, fetch the updated cart data.
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(finalCartData => {
      // Dispatch the built-in "cart:change" event with the updated cart data.
      document.dispatchEvent(new CustomEvent('cart:change', {
        detail: { cart: finalCartData },
        bubbles: true
      }));
      // Optionally, also dispatch "cart:refresh" (Prestige listens for it, too)
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { cart: finalCartData },
        bubbles: true
      }));
      
      // Now, open the cart drawer by triggering the toggle click.
      var cartToggle = document.querySelector('a[aria-controls="cart-drawer"]');
      if (cartToggle) {
        cartToggle.click();
      } else {
        console.error("Cart toggle element not found.");
      }
    })
    .catch(error => console.error("Error adding items to cart:", error));
  });


  // 8) On page load, restore previous selections or use default
  if (savedSelections && savedSelections.selectedProductIds) {
    // Reapply the saved variant IDs
    savedSelections.selectedProductIds.forEach((variantId, i) => {
      if (variantId) {
        const dropdown = document.querySelector(`.custom-dropdown[data-index="${i+1}"]`);
        if (!dropdown) return;
        const matchingOption = dropdown.querySelector(`.dropdown-option[data-variant-id="${variantId}"]`);
        if (matchingOption) matchingOption.click();
      }
    });
  } else {
    // If no saved selections, use default variant IDs
    const defaultSelections = [
      { index: 1, variantId: "44764362178756" },
      { index: 2, variantId: "44749973094596" },
      { index: 3, variantId: "44764366274756" }
    ];
    defaultSelections.forEach(sel => {
      const dropdown = document.querySelector(`.custom-dropdown[data-index="${sel.index}"]`);
      if (!dropdown) return;
      const matchingOption = dropdown.querySelector(`.dropdown-option[data-variant-id="${sel.variantId}"]`);
      if (matchingOption) matchingOption.click();
    });
  }

  // After default or saved selections, ensure pricing is updated
  updateBundlePricing();
});
